import axios from 'axios'
import React, { useState } from 'react'

import AlertCustom from './components/Alert'
import Interaction from './components/Interaction'
import LoadingGif from '../../../assets/LoadingGif'

import type { ReactNode } from 'react'
import './newsletter.scss'

interface NewsletterProps {
  title?: ReactNode
  subtitle?: ReactNode
}

interface Status {
  mensage?: string
  sucess: boolean
  error?: boolean
  info?: boolean
}

const Newsletter = ({ title }: NewsletterProps) => {
  const [status, setStatus] = useState<Status>({ mensage: '', sucess: false })
  const [loading, setLoading] = useState<boolean>(false)

  const validEmail = (email: string) => {
    const validation =
      /^([a-z]){1,}([a-z0-9._-]){1,}([@]){1}([a-z]){2,}([.]){1}([a-z]){2,}([.]?){1}([a-z]?){2,}$/i

    return validation.test(email)
  }

  const handleNewsLatter = async (email: string) => {
    if (validEmail(email)) {
      try {
        setLoading(true)
        await axios.patch('/api/newsletterApi', {
          email,
          isNewsletterOptIn: true,
        })
        setStatus({ mensage: 'E-mail cadastrado com sucesso', sucess: true })
        setLoading(false)
      } catch (err) {
        setLoading(false)

        if (err.response.status === 304) {
          setStatus({
            mensage: 'Seu e-mail já está cadastrado',
            sucess: true,
            info: true,
          })
        } else {
          setStatus({
            mensage: 'Error interno',
            sucess: false,
            error: true,
          })
        }
      }
    } else {
      setStatus({
        mensage: 'Por favor, insira um e-mail válido',
        sucess: false,
        error: true,
      })
    }
  }

  return (
    <div className="newsletter-block">
      <div data-newsletter-header className="newsletter-title">
        {loading ? (
          <div className="newsletter-loading">
            <p>Cadastrando</p> <LoadingGif />
          </div>
        ) : (
          title
        )}
      </div>
      {status.sucess || status.error ? (
        <AlertCustom setStatus={setStatus} status={status} loading={loading} />
      ) : (
        <Interaction handleNewsLatter={handleNewsLatter} />
      )}
    </div>
  )
}

export default Newsletter
